import { Base64 } from "js-base64";

import { getJwt } from "util/cookie";

export const getUserId = () => {
  const jwt = getJwt();
  return jwt ? Number(parseJwt(jwt).payload.sub) : undefined;
};

const parseJwt = (jwt: string) => {
  const [headerJson, payloadJson, signature] = jwt
    .split(".")
    .map(part => Base64.decode(part));
  return {
    header: JSON.parse(headerJson),
    payload: JSON.parse(payloadJson),
    signature,
  };
};
